import keycloak from 'auth/keycloak';
import env from './env';

const CLOUD_SAVE_CONNECTION_CHECK_URL =
  '/api/cloud-save/v1/storage-units?limit=1&offset=0';
const CLOUD_SAVE_UNREACHABLE_STATUSES = new Set([502, 503, 504]);

const withTrailingSlash = (value: string) =>
  value.endsWith('/') ? value : `${value}/`;

const getAuthCheckUrl = () =>
  new URL(`realms/${env.KEYCLOAK_REALM}`, withTrailingSlash(env.KEYCLOAK_URL));

const getCloudSaveCheckUrl = () =>
  new URL(CLOUD_SAVE_CONNECTION_CHECK_URL, window.location.origin);

export async function checkNetworkConnectivity({
  timeoutMs,
  useCloudSaveWhenAuthenticated = false,
}: {
  timeoutMs: number;
  useCloudSaveWhenAuthenticated?: boolean;
}): Promise<boolean> {
  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);
  const hasToken = !!keycloak.token;
  const useCloudSave = useCloudSaveWhenAuthenticated && hasToken;
  const url = useCloudSave ? getCloudSaveCheckUrl() : getAuthCheckUrl();
  const headers = new Headers();

  if (!useCloudSave) {
    url.searchParams.set('connection-check', Date.now().toString());
  }

  if (useCloudSave) {
    headers.set('sandvik-user-agent', 'PlantDesignerWeb/1.0.0');
    headers.set('Authorization', `Bearer ${keycloak.token}`);
  }

  try {
    const response = await fetch(url.toString(), {
      method: 'GET',
      cache: 'no-store',
      credentials: useCloudSave ? 'same-origin' : 'include',
      headers,
      signal: controller.signal,
    });

    return useCloudSave
      ? !CLOUD_SAVE_UNREACHABLE_STATUSES.has(response.status)
      : response.ok;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timeoutId);
  }
}
